import {
    useRef,
    useState,
} from 'react';
import useEffectOnUpdate from './useEffectOnUpdate';

function useCaretPosition(currentValue) {
    const ref = useRef(null);
    const [caretPosition, setCaretPosition] = useState(0);

    useEffectOnUpdate(() => {
        ref.current.setSelectionRange(caretPosition, caretPosition);
    }, [currentValue, caretPosition]);

    const onInput = () => setCaretPosition(ref.current.selectionStart);

    return { ref, onInput };
}

export default useCaretPosition;
